// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3W9E7","filesListContainer":"PosDisputesFiles_filesListContainer__1r0Ba","filesButton":"PosDisputesFiles_filesButton__1sKuf"};